import { Box, Button, Grid, Menu, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { AdvancedTableSelectPopupWrapper } from './components/advanced-table-select-popup-wrapper';

export const Wrapper = styled(AdvancedTableSelectPopupWrapper)``;

export const ContentWrapper = styled(Grid)`
  padding: ${(p) => p.theme.spacing(0.5)};
`;

export const ContentRow = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const OptionLabel = styled(Typography)``;

export const OptionButton = styled(Button)``;

export const PopoverPaper = styled(Paper)``;

export const MenuList = styled(Menu)`
  display: flex;
  flex-direction: column;
  gap: ${(p) => p.theme.spacing(0.25)};

  & .MuiListItemIcon-root {
    margin-right: 0 !important;
  }
`;
